import React from 'react';
import moment from 'moment';
import Pagination from 'react-js-pagination';
import { Table } from 'react-bootstrap';
import Loading from '../shared/Loading/Loading';

const AdminActivityTable = ({ data, handlePageChange }) => (
  <div className="col-12 mt-5">
    <Table responsive>
      <thead>
        <tr>
          <th>Date/Time</th>
          <th>Admin Name</th>
          <th>Activity</th>
        </tr>
      </thead>
      <tbody>
        {data.isLoading && (
          <tr>
            <td colSpan="3" className="loading-white-bg">
              <Loading />
            </td>
          </tr>
        )}
        {!data.isLoading &&
          data.adminLogs.length > 0 &&
          data.adminLogs.map((log) => (
            <tr key={log.id}>
              <td>{moment(log.updatedAt).format('DD MMMM YYYY, h:mm:ss a')}</td>
              <td>{log.name}</td>
              <td>{log.activity}</td>
            </tr>
          ))}
        {!data.isLoading && data.adminLogs.length === 0 && (
          <tr className="text-center">
            <td colSpan="3">
              <img
                alt="no-data-found"
                src={require('../../assets/shared/no-data.png').default}
              />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
    {data.totalData > 10 && (
      <div className="pagination-custom-style">
        <Pagination
          activePage={data.currentPage}
          itemsCountPerPage={data.perPage}
          totalItemsCount={data.totalData}
          onChange={(e) => handlePageChange(e)}
          hideFirstLastPages
          prevPageText="<PREV"
          nextPageText="NEXT>"
          activeClass="active-page"
          activeLinkClass="active-link"
          itemClass=""
          linkClass="defaul-link"
        />
      </div>
    )}
  </div>
);

export default AdminActivityTable;
